import { css } from "styled-components";
import { BorderRadius, Padding } from "../../../../../../../../../../styles/common/mixins/logical.styled.js";
const veciCounterButtonStyles = {
    CounterButtonWrapper: ()=>css`
		border-color: ${({ theme  })=>theme.border.color.light};
		${({ theme  })=>BorderRadius({
                all: theme.borderRadiusCounter
            })};
		${Padding({
            x: '8px'
        })};
		max-height: 35px;
	`
};
export default veciCounterButtonStyles;

//# sourceMappingURL=veci.js.map